import {createFileRoute} from "@tanstack/react-router"

export const Route = createFileRoute("/_mainLayout/buy/")({
  component: RouteComponent,
});

function RouteComponent() {

 return (<></>)

  // const { t } = useTranslation("buy");
  //
  // // адреса для транзакций
  // const { address: ethAddress } = useAppKitAccount({ namespace: "eip155" });
  // const { address: solAddress } = useAppKitAccount({ namespace: "solana" });
  //
  // // активная сеть
  // const { caipNetwork } = useAppKitNetwork();
  //
  // // справочники
  // const { data: currencies = [], isLoading: loadingCurr } =
  //   useGetCurrenciesQuery();
  // const { data: prices, isLoading: loadingPrices } = useGetPricesQuery(
  //   undefined,
  //   { pollingInterval: 10_000 },
  // );
  //
  // // мутация «создать заказ»
  // const [buy, { data: order }] = useBuyMutation();
  //
  // // локальный стейт
  // const [currency, setCurrency] = useState<string>("");
  // const [network, setNetwork] = useState<string>("");
  // const [amount, setAmount] = useState<string>("1");
  // const [znxAmount, setZnxAmount] = useState<string>("0");
  // const [sellAmount, setSellAmount] = useState<string>("0");
  //
  // // 1) все уникальные токены
  // const tokenNames = useMemo(
  //   () => Array.from(new Set(currencies.map((c) => c.name))),
  //   [currencies],
  // );
  //
  // // 2) дефолтный токен
  // useEffect(() => {
  //   if (!currency && tokenNames.length) {
  //     setCurrency(tokenNames[0]);
  //   }
  // }, [tokenNames, currency]);
  //
  // // 3) если выбран ZNX — жёстко SOL
  // useEffect(() => {
  //   if (currency === "ZNX") {
  //     setNetwork("SOL");
  //   }
  // }, [currency]);
  //
  // // 4) для прочих токенов — дефолтная сеть из справочника
  // const defaultNetwork = useMemo(() => {
  //   const nets = currencies.filter((c) => c.name === currency);
  //   return nets.length ? nets[0].networkCode : "";
  // }, [currency, currencies]);
  // useEffect(() => {
  //   if (currency !== "ZNX" && defaultNetwork) {
  //     setNetwork(defaultNetwork);
  //   }
  // }, [defaultNetwork, currency]);
  //
  // // 5) пересчёт ZNX при покупке
  // const recalcBuy = useCallback(
  //   debounce((amt: string, curr: string) => {
  //     const q = prices?.Buy?.find((x) => x.GiveName === curr);
  //     setZnxAmount(q ? (parseFloat(q.TakeValue) * +amt).toFixed(6) : "0");
  //   }, 300),
  //   [prices],
  // );
  // useEffect(() => {
  //   if (currency !== "ZNX") {
  //     recalcBuy(amount, currency);
  //   }
  // }, [amount, currency, recalcBuy]);
  //
  // // 6) пересчёт SOL при продаже ZNX
  // useEffect(() => {
  //   if (currency === "ZNX") {
  //     const entry = prices?.Sell?.find(
  //       (e) => e.GiveName === "ZNX" && e.TakeName === "SOL",
  //     );
  //     setSellAmount(
  //       entry ? (parseFloat(entry.TakeValue) * +amount).toFixed(6) : "0",
  //     );
  //   }
  // }, [amount, currency, prices]);
  //
  // // 7) валидация min/max
  // const current = currencies.find(
  //   (c) => c.name === currency && c.networkCode === network,
  // );
  // const min = current ? parseFloat(current.minDeposit) : 0;
  // const max =
  //   current && parseFloat(current.maxDeposit)
  //     ? parseFloat(current.maxDeposit)
  //     : Infinity;
  // const num = parseFloat(amount || "0");
  // const isAmountValid = !isNaN(num) && num >= min && num <= max;
  //
  // // 8) авто-buy при смене пары (пример — здесь просто логируем)
  // const prevPair = useRef({ c: "", n: "" });
  // useEffect(() => {
  //   const { c: pc, n: pn } = prevPair.current;
  //   if (pc || pn) {
  //     // если сменился токен или сеть — запускаем buy
  //     if ((currency !== pc || network !== pn) && currency !== "ZNX") {
  //       buy({ currency, network });
  //     }
  //   }
  //   prevPair.current = { c: currency, n: network };
  // }, [currency, network, buy]);
  //
  // // 9) polling для REQUESTED
  // useEffect(() => {
  //   if (order?.status === "REQUESTED") {
  //     const timer = setTimeout(() => buy({ currency, network }), 2000);
  //     return () => clearTimeout(timer);
  //   }
  // }, [order, buy, currency, network]);
  //
  // // загрузка
  // if (loadingCurr || loadingPrices) {
  //   return (
  //     <div className={styles.spinner}>
  //       <ClipLoader color="#0efa7e" />
  //     </div>
  //   );
  // }
  //
  // // в какой сети сейчас пользователь
  // const isSolana = caipNetwork?.name === "Solana";
  //
  // return (
  //   <div className={styles.container}>
  //     <appkit-network-button />
  //
  //     {/* выбор токена */}
  //     <label>
  //       {t("currency")}
  //       <select value={currency} onChange={(e) => setCurrency(e.target.value)}>
  //         {tokenNames.map((n) => (
  //           <option key={n} value={n}>
  //             {n}
  //           </option>
  //         ))}
  //       </select>
  //     </label>
  //
  //     {/* выбор сети только при покупке */}
  //     {currency !== "ZNX" && (
  //       <label>
  //         {t("network")}
  //         <select value={network} onChange={(e) => setNetwork(e.target.value)}>
  //           {currencies
  //             .filter((c) => c.name === currency)
  //             .map((c) => (
  //               <option key={c.networkCode} value={c.networkCode}>
  //                 {c.networkName}
  //               </option>
  //             ))}
  //         </select>
  //       </label>
  //     )}
  //
  //     {/* ввод суммы */}
  //     <label>
  //       {t("sum")} ({currency})
  //       <input
  //         type="number"
  //         value={amount}
  //         onChange={(e) => setAmount(e.target.value)}
  //         min={min}
  //         max={isFinite(max) ? max : undefined}
  //       />
  //       {!isAmountValid && (
  //         <div className={styles.error}>
  //           {t("min")} {min}, {t("max")} {isFinite(max) ? max : "∞"}
  //         </div>
  //       )}
  //     </label>
  //
  //     {/* покупка */}
  //     {currency !== "ZNX" && (
  //       <>
  //         <div className={styles.result}>≈ {znxAmount} ZNX</div>
  //         {order?.status === "SUCCESS" && (
  //           <div>
  //             {isSolana ? (
  //               <SolanaSendTransactionTest
  //                 amount={amount}
  //                 recipient={order.address}
  //               />
  //             ) : ethAddress ? (
  //               <EthersTransactionTest
  //                 amount={amount}
  //                 recipient={order.address}
  //                 address={ethAddress}
  //               />
  //             ) : null}
  //           </div>
  //         )}
  //       </>
  //     )}
  //
  //     {/* продажа ZNX → SOL */}
  //     {currency === "ZNX" && (
  //       <>
  //         <div className={styles.result}>≈ {sellAmount} SOL</div>
  //         {order?.status === "SUCCESS" && solAddress && (
  //           <SolanaSendTransactionTest
  //             amount={sellAmount}
  //             recipient={solAddress}
  //           />
  //         )}
  //       </>
  //     )}
  //   </div>
  // );

}
